<cdk-virtual-scroll-viewport tvsItemSize="40"
    [ngClass]="isInWizard ? 'tableDivWiz' : isStandAlone ? 'tableDiv' : 'tableDiv'" *ngIf="isTableLoaded">
    <table mat-table matSort [dataSource]="dataSource" (matSortChange)="sortData($event)" class="mat-table-sort-mod">

        <ng-container *ngFor="let col of displayedColumns" [matColumnDef]="col">
            <th [class]="styles.headerCol" mat-header-cell *matHeaderCellDef #header mat-sort-header
                [style.font-size.px]="headerFontSize" [style.color]="headerColor"
                [matTooltip]="getColumnDescription(col)" matTooltipClass="tooltip-font-14 no-break" [matTooltipPosition]="'above'"
                [sortActionDescription]="'Sort by ' + col" [class.standalone]="isStandAlone" >
               <div class="col-name-container">{{ getColumnName(col) }}</div>
               <div style="margin-left: 10px ;">
                <i class="fad fa-sort"
                  [class.fa-sort-down]="header['_sort'].active == col && header['_sort'].direction=='desc'"
                  [class.fa-sort-up]="header['_sort'].active == col && header['_sort'].direction=='asc'"></i>
               </div>
            </th>
            <td [class]="styles.rowCol" mat-cell *matCellDef="let row" [style.font-size.px]="rowFontSize" [class.computedTotal]="row.computedTotal"
                [style.color]="rowColor"> {{!this.specialReportProperties?.totalsOnlyColumnsObj?.[col] || row.isTotal ? row[col] : "" }}
              </td>


            <th [class]="styles.rowCol" [style.color]="headerColor" mat-footer-cell *matFooterCellDef>{{getColumnFooter(col)}} </th>

          </ng-container>

        <tr [ngClass]="groupByTime?.trim().length > 0 ? ['group-table-header', styles.header] : styles.header"
            mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr [ngClass]="row.isOdd ? groupByTime?.trim().length > 0 ? ['group-table-row', styles.oddRow] : styles.oddRow : groupByTime?.trim().length > 0 ? ['group-table-row', styles.evenRow] : styles.evenRow"
            mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        <ng-container matColumnDef="groupHeader">
            <td colspan="999" mat-cell *matCellDef="let group">
                <span><strong>{{group.groupName}}</strong></span>
            </td>
        </ng-container>
        <ng-container matColumnDef="groupReducer">
            <td colspan="1" mat-cell *matCellDef="let group">
                <div fxFill fxLayoutAlign="center center">
                    <i *ngIf="!group.reduced" class="fas fa-minus"></i>
                    <i *ngIf="group.reduced" class="fas fa-plus"></i>
                </div>
            </td>
        </ng-container>

        <tr mat-row class="clickable" *matRowDef="let row; columns: ['groupReducer','groupHeader']; when: isGroup"
            (click)="reduceGroup(row)">
        </tr>

        <tr *matRowDef="let row; columns: displayedColumns; when: isTotal" mat-row style="font-weight: bold;"
            [style.font-size.px]="rowFontSize" [style.color]="rowColor" [style.backgroundColor]="subTotalsColor">
        </tr>
        <ng-container *ngIf="showTotal">
          <tr mat-footer-row *matFooterRowDef="displayedColumns" class="table-footer-row" [style.background]="grandTotalColor"></tr>
        </ng-container>
    </table>
</cdk-virtual-scroll-viewport>
